(function () {
  const BAR_SELECTOR = "[data-offer-bar]";
  const TIMER_SELECTOR = "[data-offer-time]";
  const TOPTEXT_SELECTOR = ".offer-countdown-bar__toptext";
  const LABEL_SELECTOR = "[data-offer-label]";
  const COPY_BTN_SELECTOR = "[data-copy-code]";

  const KEY_END_AT = "genvix_offer_end_at_v1";

  // Tiers in ₹
  const TIERS = [599, 999, 1299, 1499];

  function pad2(n) {
    return String(n).padStart(2, "0");
  }

  function formatMMSS(totalSeconds) {
    const m = Math.floor(totalSeconds / 60);
    const s = totalSeconds % 60;
    return pad2(m) + " MIN : " + pad2(s) + " SEC";
  }

  function nowMs() {
    return Date.now();
  }

  function safeParseInt(v, fallback) {
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function setEndAt(durationMinutes) {
    const endAt = nowMs() + durationMinutes * 60 * 1000;
    localStorage.setItem(KEY_END_AT, String(endAt));
    return endAt;
  }

  function getEndAt(durationMinutes) {
    const stored = localStorage.getItem(KEY_END_AT);
    const endAt = safeParseInt(stored, 0);
    if (!endAt || endAt < nowMs()) return setEndAt(durationMinutes);
    return endAt;
  }

  // PRE-discount base subtotal in paise
  async function getCartBasePaise() {
    const r = await fetch("/cart.js", { credentials: "same-origin" });
    const cart = await r.json();

    const basePaise =
      cart.items_subtotal_price != null
        ? Number(cart.items_subtotal_price)
        : (Number(cart.total_price || 0) + Number(cart.total_discount || 0));

    return basePaise;
  }

  function ensureSecondLine(bar) {
    let labelEl = bar.querySelector(LABEL_SELECTOR);
    if (labelEl) return labelEl;

    labelEl = document.createElement("div");
    labelEl.setAttribute("data-offer-label", "");
    labelEl.className = "offer-countdown-bar__label gx-offer-line2";
    bar.appendChild(labelEl);
    return labelEl;
  }

  function setTopPrefixKeepingTimer(topTextEl, prefixText) {
    if (!topTextEl) return;

    const first = topTextEl.childNodes && topTextEl.childNodes[0];
    if (first && first.nodeType === Node.TEXT_NODE) {
      first.textContent = prefixText;
    } else {
      topTextEl.insertBefore(document.createTextNode(prefixText), topTextEl.firstChild);
    }
  }

  function hideCouponUI(bar) {
    // hide copy button
    const copyBtn = bar.querySelector(COPY_BTN_SELECTOR);
    if (copyBtn) copyBtn.style.display = "none";

    // hide visible code element if present
    const codeEl = bar.querySelector(".offer-countdown-bar__code");
    if (codeEl) codeEl.style.display = "none";

    // hide coupon phrases but never hide timer
    const timerEl = bar.querySelector(TIMER_SELECTOR);
    const kill = ["use discount code", "discount code", "copy code", "to avail", "hurry now", "genvix10"];

    bar.querySelectorAll("*").forEach((el) => {
      if (timerEl && el.contains(timerEl)) return;
      const t = (el.textContent || "").toLowerCase();
      if (kill.some((k) => t.includes(k))) el.style.display = "none";
    });
  }

  function computeRemainingFromSubtotalRs(subtotalRs) {
    const nextTier = TIERS.find((t) => subtotalRs < t);
    if (!nextTier) return 0;
    return Math.max(0, nextTier - subtotalRs);
  }

  function initBar(bar) {
    const timerEl = bar.querySelector(TIMER_SELECTOR);
    const topTextEl = bar.querySelector(TOPTEXT_SELECTOR);
    const labelEl = ensureSecondLine(bar);

    const durationMinutes = safeParseInt(bar.getAttribute("data-duration-minutes"), 15);
    const endBehavior = (bar.getAttribute("data-end-behavior") || "reset").toLowerCase();

    let endAt = getEndAt(durationMinutes);
    let tickId = null;

    let cachedRemaining = null; // ₹ number, or null
    let lastCartFetchAt = 0;

    async function updateCartRemaining() {
      const now = Date.now();
      if (now - lastCartFetchAt < 3000) return; // refresh every 3s
      lastCartFetchAt = now;

      try {
        const basePaise = await getCartBasePaise();
        const subtotalRs = Math.round(basePaise / 100);
        cachedRemaining = computeRemainingFromSubtotalRs(subtotalRs);
      } catch (e) {
        cachedRemaining = null;
      }
    }

    function render() {
      const remainingMs = endAt - nowMs();
      const remainingSeconds = Math.max(0, Math.floor(remainingMs / 1000));

      // ✅ Urgent mode: remove "Offer Ends In" text completely
      if (remainingSeconds <= 120 && remainingSeconds > 0) {
        bar.classList.add("is-urgent");
        setTopPrefixKeepingTimer(topTextEl, "LAST 2 MINUTES! Grab the Deal ");
      } else {
        bar.classList.remove("is-urgent");
        setTopPrefixKeepingTimer(topTextEl, ""); // no prefix
      }

      if (timerEl) {
        timerEl.textContent = formatMMSS(remainingSeconds);
        timerEl.style.display = "";
      }

      // Second line
      if (cachedRemaining === 0) {
        labelEl.textContent = "🎉 Best savings unlocked — complete your order";
      } else if (typeof cachedRemaining === "number") {
        labelEl.textContent =
          "🎁 Extra savings waiting — Just ₹" + cachedRemaining + " away from unlocking more value";
      } else {
        labelEl.textContent = "🎁 Extra savings waiting — add more to unlock more value";
      }

      // End behavior
      if (remainingSeconds <= 0) {
        if (endBehavior === "ended") {
          stop();
        } else {
          endAt = setEndAt(durationMinutes);
        }
      }
    }

    function start() {
      hideCouponUI(bar);
      updateCartRemaining();
      render();

      tickId = window.setInterval(function () {
        updateCartRemaining();
        render();
      }, 1000);
    }

    function stop() {
      if (tickId) window.clearInterval(tickId);
      tickId = null;
    }

    start();
  }

  function boot() {
    document.querySelectorAll(BAR_SELECTOR).forEach(initBar);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
